import React, { useState } from 'react';
import './Customersupport.css';
import Header from './Header';
import Footer from './Footer';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const Customersupport = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const response = await fetch('https://api.ndtechland.com/api/HomeApi/Contactus', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                Name: formData.name,
                Email: formData.email,
                Message: formData.message,
            }),
        });

        if (response.ok) {
            alert('Your message has been sent successfully!');
            setFormData({ name: '', email: '', message: '' });
        } else {
            alert('There was an error sending your message. Please try again.');
        }
    };

    return (
        <div>
            <Header />

            <div className="nd-support-page">
                <div className="nd-support-container container">
                    {/* Hero Header */}
                    <div className="nd-support-hero">
                        <div className="nd-support-badge">Help & Support Desk</div>
                        <h1 className="nd-support-title">Customer Support</h1>
                    </div>

                    {/* 2-Column Split Grid */}
                    <div className="nd-support-grid">
                        {/* Support Form Card */}
                        <div className="nd-support-form-card">
                            <h2>Submit a Request</h2>
                            <form className="nd-support-form-content" onSubmit={handleSubmit}>
                                <div className="nd-support-form-group">
                                    <label htmlFor="name">Name:</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder="Enter your name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="nd-support-form-group">
                                    <label htmlFor="email">Email:</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="Enter your email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        style={{ width: "100%", textAlign: "left" }}
                                    />
                                </div>
                                <div className="nd-support-form-group">
                                    <label htmlFor="message">Message:</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        placeholder="How can our support team assist you?"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        style={{ width: "100%", textAlign: "left" }}
                                    />
                                </div>
                                <button type="submit" className="nd-support-submit-btn">
                                    Submit
                                </button>
                            </form>
                        </div>

                        {/* Support Info Card */}
                        <div className="nd-support-info-card">
                            <h2>Contact Us</h2>
                            <p className="nd-support-lead-text">For immediate assistance, please contact us:</p>

                            <div className="nd-support-contact-list">
                                <div className="nd-support-contact-item">
                                    <div className="nd-support-contact-icon-box">
                                        <FaMapMarkerAlt />
                                    </div>
                                    <div className="nd-support-contact-info">
                                        <p><strong>Address:</strong></p>
                                        <p>D-159, First Floor, Sector 7, Noida, Uttar Pradesh-201301</p>
                                    </div>
                                </div>

                                <div className="nd-support-contact-item">
                                    <div className="nd-support-contact-icon-box">
                                        <FaPhoneAlt />
                                    </div>
                                    <div className="nd-support-contact-info">
                                        <p><strong>Phone:</strong>91 8826302378</p>
                                    </div>
                                </div>

                                <div className="nd-support-contact-item">
                                    <div className="nd-support-contact-icon-box">
                                        <FaEnvelope />
                                    </div>
                                    <div className="nd-support-contact-info">
                                        <p><strong>Email:</strong> <a href="mailto:info@ndtechland.com">help@ndtechland.com</a></p>
                                    </div>
                                </div>
                            </div>

                            <div className="nd-support-hours-box">
                                <p>Hours: Monday to Satursday, 9:30 AM - 6:30 PM</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Customersupport;
